/**
 * @generated SignedSource<<1c2d10a4fedf19285d6f34be5b3b9c4a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderEditFlightTicket_order$data = {
  readonly flightTicket: {
    readonly " $fragmentSpreads": FragmentRefs<"StoredFile_file">;
  } | null;
  readonly id: string;
  readonly " $fragmentType": "OrderEditFlightTicket_order";
};
export type OrderEditFlightTicket_order$key = {
  readonly " $data"?: OrderEditFlightTicket_order$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrderEditFlightTicket_order">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrderEditFlightTicket_order",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoredFile",
      "kind": "LinkedField",
      "name": "flightTicket",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StoredFile_file"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Order",
  "abstractKey": null
};

(node as any).hash = "0fcd06ab99a3b19437c5517280403051";

export default node;
